import { AppBar, Box, Button, Link, Toolbar, Typography, } from '@mui/material';
import React from "react";
import { useTranslation } from "react-i18next";
import Logo from "../../src/assets/images/login/logo.svg"
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { ReactComponent as LogoMain } from "../assets/images/logo.svg";
import { useNavigate } from "react-router-dom";

const MainNavbar = (props) => {
    const Start = useSelector((state) => state.Start);
    const logo = localStorage.getItem("logo");
    const vLogo = Start?.data?.client?.logo ? Start?.data?.client?.logo : "";
    const useStyles = makeStyles({
        fill: {
            '& > path': {
                fill: "#404349"
            },
            '& g > path': {
                fill: "#404349"
            },
        },
    });
    const classes = useStyles();
    const navigate = useNavigate();

    const { t } = useTranslation()
    function open() {
        // alert('woohoo handleMenu')
    }
    function handleMenu() {
        // alert('woohoo handleMenu')
    }
    function handleClose() {
        // alert('woohoo handleClose')
    }

    // const Start = useSelector((state) => state.Start);
    // const logo = localStorage.getItem("logo");
    // const vLogo = Start?.data?.client?.logo ? Start?.data?.client?.logo : "";

    return (
        <AppBar
            elevation={0}
            {...props}
            // color="#404349"
            style={{ backgroundColor: '#404349' }}
        >
            <Toolbar>
                {/* <Box>
                    <img src={vLogo !== "" ? vLogo : logo} alt="React Logo" />
                </Box> */}
                {logo &&
                    <Box mr="30px">
                        <img style={{ maxHeight: '40px' }} src={logo} alt="IPOP PMS" />
                    </Box>
                }
                <LogoMain />
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                </Typography>
                <Button color="inherit"> <Link href="https://ipop-hr.iamconsulting.co.th/" target="_blank" underline="none" color="#FFFFFF" sx={{ fontWeight: "400" }}>{t('label.about')}</Link></Button>
                <Button color="inherit"><Link href="mailto:support@pinno.io" target="_blank" underline="none" color="#FFFFFF" sx={{ fontWeight: "400" }}> {t('label.contact')}</Link></Button>
                <Button onClick={() => navigate(`/`, { replace: false })} id="signin" color="button_primary" variant="contained">{t('login.label.signin')}</Button>
            </Toolbar>
        </AppBar>
    )
};
export default MainNavbar;
